// extracted by mini-css-extract-plugin
export default {"avtarWrapper":"ProfileInformation_avtarWrapper__kemKr","descriptionLabel":"ProfileInformation_descriptionLabel__SWDZW"};